import { render, staticRenderFns } from "./LogForm.vue?vue&type=template&id=531856ba&"
import script from "./LogForm.vue?vue&type=script&lang=js&"
export * from "./LogForm.vue?vue&type=script&lang=js&"
import style0 from "./LogForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports